import React from "react";
import { ISSUES_COLUMN_WIDTH } from "../../../constants";
import Sort from "./Sort";
/**
 * The standard three-column component-list layout (priority/issues, file name,
 * file path) with sortable headers wired to `ComponentList.Sort`. Passed to a
 * `ComponentList.Table` (and therefore `DataTable`) `columns` prop; prepend or
 * append columns for the few tables that need extra ones.
 */
export const getComponentListColumns = ({ sortBy, rowIndex, onSortChange, }) => [
    {
        id: "grade",
        width: ISSUES_COLUMN_WIDTH,
        header: (React.createElement(Sort, { sortBy: sortBy, column: "grade", index: rowIndex, onSortChange: onSortChange })),
    },
    {
        id: "file_name",
        width: "40%",
        header: (React.createElement(Sort, { sortBy: sortBy, column: "file_name", index: rowIndex, onSortChange: onSortChange })),
    },
    {
        id: "file_path",
        width: "60%",
        header: (React.createElement(Sort, { sortBy: sortBy, column: "file_path", index: rowIndex, onSortChange: onSortChange })),
    },
];
//# sourceMappingURL=columns.js.map